<script setup>
  defineOptions({
    name: "ComponentDoctorIcon",
  });
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" :data-test="getTestId('icon-svg-doctor')">
    <g fill="none" stroke="currentColor" transform="scale(0.44), translate(7,7)">
      <g stroke-width="4">
        <path
          d="M3.636 3.89c-4.787 20.066 9.147 22.778 9.147 22.778M21.15 3.89c4.421 18.838-8.368 22.778-8.368 22.778"
        />
      </g>
      <path stroke-linecap="round" stroke-width="3" d="M1.819 4.156l4-1M18.799 3.27l4.1.43" />
      <g stroke-width="3">
        <circle cx="33.2" cy="17.6" r="4.5" />
      </g>
      <path d="M12.774 26.583c-.7 5.1 4.059 11.466 12.484 10.131s8.075-8.975 7.882-15.05" stroke-width="4" />
    </g>
  </svg>
</template>
